module.exports = __webpack_public_path__ + "static/media/SFH17.f346aaa1.png";